import { render, staticRenderFns } from "./kbxmList.vue?vue&type=template&id=b1d84a92&"
import script from "./kbxmList.vue?vue&type=script&lang=js&"
export * from "./kbxmList.vue?vue&type=script&lang=js&"
import style0 from "./kbxmList.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports